import { configureStore } from '@reduxjs/toolkit';
import uiSlice from './slices/uiSlice';
import analyticsSlice from './slices/analyticsSlice';
import branchesSlice from './slices/branchesSlice';
import medicinesSlice from './slices/medicinesSlice';
import inventorySlice from './slices/inventorySlice';
import salesSlice from './slices/salesSlice';
import sellerMedicineSlice from './slices/sellerMedicineSlice';
import patientSlice from './slices/patientSlice';
import prescriptionSlice from './slices/prescriptionSlice';

export const store = configureStore({
  reducer: {
    ui: uiSlice,
    analytics: analyticsSlice,
    branches: branchesSlice,
    medicines: medicinesSlice,
    inventory: inventorySlice,
    sales: salesSlice,
    sellerMedicines: sellerMedicineSlice,
    patient: patientSlice,
    prescription: prescriptionSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
